/**
 * @generated SignedSource<<80405e47ee05ec989e45f86ab78bb0e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MovedEventToSeries = {
  id: string;
  targetSeries: string;
};
export type SeriesDetailsContentMutation$variables = {
  addedEvents: ReadonlyArray<string>;
  id: string;
  movedEvents: ReadonlyArray<MovedEventToSeries>;
  removedEvents: ReadonlyArray<string>;
};
export type SeriesDetailsContentMutation$data = {
  readonly updateSeriesContent: {
    readonly entries: ReadonlyArray<{
      readonly __typename: "AuthorizedEvent";
      readonly canWrite: boolean;
      readonly created: string;
      readonly creators: ReadonlyArray<string>;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly isLive: boolean;
      readonly syncedData: {
        readonly audioOnly: boolean;
        readonly duration: number;
        readonly endTime: string | null | undefined;
        readonly startTime: string | null | undefined;
        readonly thumbnail: string | null | undefined;
      } | null | undefined;
      readonly title: string;
    } | {
      readonly __typename: "Missing";
      readonly __typename: "Missing";
    } | {
      readonly __typename: "NotAllowed";
      readonly __typename: "NotAllowed";
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    }>;
  };
};
export type SeriesDetailsContentMutation = {
  response: SeriesDetailsContentMutation$data;
  variables: SeriesDetailsContentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "addedEvents"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "movedEvents"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "removedEvents"
},
v4 = [
  {
    "kind": "Variable",
    "name": "addedEvents",
    "variableName": "addedEvents"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "movedEvents",
    "variableName": "movedEvents"
  },
  {
    "kind": "Variable",
    "name": "removedEvents",
    "variableName": "removedEvents"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "created",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creators",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canWrite",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SyncedEventData",
      "kind": "LinkedField",
      "name": "syncedData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "thumbnail",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "audioOnly",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "duration",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endTime",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AuthorizedEvent",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SeriesDetailsContentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Series",
        "kind": "LinkedField",
        "name": "updateSeriesContent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "entries",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "SeriesDetailsContentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Series",
        "kind": "LinkedField",
        "name": "updateSeriesContent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "entries",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "69a45905d094f95bddfcff1f47bc9942",
    "id": null,
    "metadata": {},
    "name": "SeriesDetailsContentMutation",
    "operationKind": "mutation",
    "text": "mutation SeriesDetailsContentMutation(\n  $id: ID!\n  $addedEvents: [ID!]!\n  $removedEvents: [ID!]!\n  $movedEvents: [MovedEventToSeries!]!\n) {\n  updateSeriesContent(id: $id, addedEvents: $addedEvents, removedEvents: $removedEvents, movedEvents: $movedEvents) {\n    entries {\n      __typename\n      ... on AuthorizedEvent {\n        id\n        isLive\n        title\n        created\n        creators\n        description\n        canWrite\n        syncedData {\n          thumbnail\n          audioOnly\n          duration\n          startTime\n          endTime\n        }\n      }\n      ... on Missing {\n        __typename\n      }\n      ... on NotAllowed {\n        __typename\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "a35711de61a48ed8c55f4f0a8ebdcafc";

export default node;
